(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9747],{

/***/ 7033:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/tooltip.396c7bfc.svg","height":30,"width":30});

/***/ }),

/***/ 5852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Bundles_StaticBundle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./components/Bundles/localization.js
var localization = __webpack_require__(60303);
// EXTERNAL MODULE: ./components/Shared/Image/index.js
var Image = __webpack_require__(70914);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./components/cart/cartAnalytics.js
var cartAnalytics = __webpack_require__(96514);
// EXTERNAL MODULE: ./components/Bundles/StaticBundle/BundlesViewDetails/BundleChildItems/index.module.scss
var index_module = __webpack_require__(5777);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/cart/CartItemTile/analytics.js
var analytics = __webpack_require__(69162);
;// CONCATENATED MODULE: ./components/Bundles/StaticBundle/BundlesViewDetails/BundleChildItems/index.js














const BundleChildItems = (props)=>{
    var ref;
    const { data ={} , pdpView =false , page =""  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { colorOrFinish ="" , qty =0 , cannotShipLabel , outOfStockLabel  } = (0,localization/* getTranslations */.F)(t);
    const [productPdpUrl, setProductPdpUrl] = (0,react.useState)("");
    const siteName = (0,react.useRef)(null);
    const { name ="" , desc ="" , sku ="" , category ="" , slug ="" , image ="" , color ="" , quantity =0 , currencySign ="$" , totalPrice =0 , unitPrice =0 , discountedPrice =0 , noShipping =false , outOfStock =false  } = data;
    const productName = name ? "".concat(name, " ").concat(!pdpView ? desc : "") : desc;
    (0,react.useEffect)(()=>{
        if (category && slug && sku) {
            (0,helper/* getPDPUrl */.ir5)(category, slug).then((pdpUrl)=>{
                const param = sku ? "skuId=".concat(sku) : "";
                const redirectUrl = (0,utils/* getPdpRedirectUrl */.Om)(pdpUrl, param);
                setProductPdpUrl(redirectUrl);
            });
        }
    }, [
        category,
        slug,
        sku
    ]);
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            siteName.current = get_default()(config, "general.siteName", "");
        });
    }, []);
    const customerFacingSKUId = data.customerFacingSKU || data.sku;
    const cartItemProductInfo = JSON.stringify({
        productInfo: {
            productBrand: (ref = siteName.current) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
            description: (0,helper/* sanitizeTextForAnalytics */.T68)(data.desc),
            globalPromotionPrice: Number(data.discountedPrice) ? Number(data.discountedPrice) : Number(data.unitPrice),
            priceState: data.discountPercent > 0 ? "percentOff|" + data.discountPercent : "regular price",
            productBasePrice: Number(data.unitPrice),
            productCategory: (0,helper/* sanitizeTextForAnalytics */.T68)(data.category),
            productColor: (0,helper/* sanitizeTextForAnalytics */.T68)(data.color) || "n/a",
            productID: customerFacingSKUId,
            productName: (0,helper/* sanitizeTextForAnalytics */.T68)(data.name),
            productRoom: (0,helper/* sanitizeTextForAnalytics */.T68)(data.category),
            productSalePrice: Number(data.discountedPrice) ? Number(data.discountedPrice) : Number(data.unitPrice),
            productStatus: data.outOfStock && data.availableQty < 1 ? "out of stock" : "in stock",
            productSuperSku: data.superSku ? true : false,
            productTileName: (0,helper/* sanitizeTextForAnalytics */.T68)(data.name),
            quantity: data.quantity,
            defaultImageName: data.image,
            productCollectionsName: (0,helper/* sanitizeTextForAnalytics */.T68)(data.productCollectionsName || data.category),
            productCoupondiscount: "n/a",
            productPartnerBuyNow: "true",
            productSaleable: "true",
            isRecommended: "true",
            isSendNow: "true",
            isSubscription: "true",
            frequency: "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a",
            pdpType: "bundle",
            productFindingMethod: "n/a"
        }
    });
    const productPrice = discountedPrice ? discountedPrice : unitPrice;
    const handleProductClickAnalytics = ()=>{
        const eventInfo = (0,cartAnalytics/* addCartItemSummaryAnalytics */.Jk)(page, data.desc, data.name, productPdpUrl, true);
        (0,analytics/* cartItemSummaryAnalytics */.$y)(eventInfo, cartItemProductInfo);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).ChildItems,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: productPdpUrl,
                    onClick: handleProductClickAnalytics,
                    className: "gbh-data-layer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: image,
                        alt: productName,
                        fill: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "information-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: productPdpUrl,
                        className: "list-title",
                        onClick: handleProductClickAnalytics,
                        children: productName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "attributes",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    colorOrFinish,
                                    ":",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "attributes-details",
                                        children: color
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    qty,
                                    ":",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "attributes-details",
                                        children: quantity
                                    }),
                                    pdpView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "price-group mobile",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "price",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    value: unitPrice,
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    prefix: currencySign,
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true
                                                })
                                            }),
                                            discountedPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "linethrough",
                                                children: [
                                                    currencySign,
                                                    unitPrice
                                                ]
                                            }) : null
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "preview-cart-bundle-price",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "price-divider",
                                                children: "/"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                value: totalPrice,
                                                displayType: "text",
                                                thousandSeparator: true,
                                                prefix: currencySign,
                                                decimalScale: 2,
                                                fixedDecimalScale: true
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    noShipping ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cart-item__stock-msg --error",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: cannotShipLabel
                        })
                    }) : null,
                    outOfStock ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "error",
                        children: outOfStockLabel
                    }) : null
                ]
            }),
            pdpView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "price-group",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "price",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                            value: productPrice,
                            displayType: "text",
                            thousandSeparator: true,
                            prefix: currencySign,
                            decimalScale: 2,
                            fixedDecimalScale: true
                        })
                    }),
                    discountedPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "linethrough",
                        children: [
                            currencySign,
                            unitPrice
                        ]
                    }) : null
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var BundlesViewDetails_BundleChildItems = (BundleChildItems);

// EXTERNAL MODULE: ./components/Bundles/StaticBundle/index.module.scss
var StaticBundle_index_module = __webpack_require__(58177);
var StaticBundle_index_module_default = /*#__PURE__*/__webpack_require__.n(StaticBundle_index_module);
;// CONCATENATED MODULE: ./components/Bundles/StaticBundle/index.jsx







const StaticBundle = (props)=>{
    const { isViewBundle ="" , pdpView , data , page =""  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,localization/* getTranslations */.F)(t);
    const { productPrice =0 , currencySign ="" , // listPrice = 0,
    lineItem =[]  } = data;
    const { includedPdpItemsLabel , subTotalItems =()=>{}  } = staticText;
    // const percentOff = 100 - Math.round((productPrice / listPrice) * 100)
    const totalItems = lineItem.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (StaticBundle_index_module_default()).BundleSectionWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bundles ".concat(isViewBundle ? "preview-cart-bundles" : "fade-out"),
            children: [
                pdpView ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "include-item",
                    children: includedPdpItemsLabel
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lists ".concat(pdpView ? "pdp-bundle-lists" : ""),
                    children: lineItem.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BundlesViewDetails_BundleChildItems, {
                                data: item,
                                pdpView: pdpView,
                                page: page
                            })
                        }, item.id))
                }),
                pdpView ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bundles-bottom-section",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "price-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "subtotal",
                                children: subTotalItems(totalItems)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "bundles-total-price",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: productPrice,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                })
                            })
                        ]
                    })
                }) : null
            ]
        })
    });
};
/* harmony default export */ var Bundles_StaticBundle = (StaticBundle);


/***/ }),

/***/ 34252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JP": function() { return /* binding */ viewDetailsBundleAnalytics; },
/* harmony export */   "UQ": function() { return /* binding */ accordianClickBundleFeature; },
/* harmony export */   "V8": function() { return /* binding */ viewMoreBundleFeature; },
/* harmony export */   "si": function() { return /* binding */ addAnlyticsForSDownloadSpec; }
/* harmony export */ });
const viewDetailsBundleAnalytics = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const eventInfo = {
        eventAction: "cart preview:view details:".concat(title),
        eventName: "cart preview:view details:".concat(title),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view details:".concat(title),
        internalLinkPosition: "cart:bundle",
        internalLinkType: "cart:view details",
        internalLinkZoneName: "cart:preview",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo ? productInfo.productInfo : "");
};
const addAnlyticsForSDownloadSpec = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", selectedFileList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], techFils = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], mainTitle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { productInfo  } = page;
    const techFilsLists = techFils.map((selectedObj)=>selectedObj.toLowerCase());
    const eventInfo = {
        eventAction: "pdp:".concat(mainTitle, ":").concat(title),
        eventName: "pdp:".concat(mainTitle, ":").concat(title),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "success",
        internalLinkName: "".concat(title, "|").concat(selectedFileList.join(":").toLowerCase()),
        internalLinkPosition: "pdp:bundle",
        internalLinkType: "pdp:".concat(mainTitle, ":").concat(title),
        internalLinkZoneName: "pdp:".concat(mainTitle),
        internalLinkURL: techFilsLists.join(":"),
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const viewMoreBundleFeature = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { productInfo  } = page;
    const eventInfo = {
        eventAction: "pdp:specs:view more",
        eventName: "pdp:specs:view more",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view more",
        internalLinkPosition: "pdp:bundle",
        internalLinkType: "pdp:specs:view more",
        internalLinkZoneName: "pdp:specs",
        internalLinkURL: "".concat(window.location.origin).concat(url),
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const accordianClickBundleFeature = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", accordianState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { productInfo  } = page;
    const eventInfo = {
        eventAction: "pdp:product details:filters ".concat(accordianState),
        eventName: "pdp:product details:filters ".concat(accordianState),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: accordianState,
        internalLinkPosition: "pdp:bundle",
        internalLinkType: "pdp:".concat(title),
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};


/***/ }),

/***/ 60303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        viewDetails: t("kf.pdp.bundles.viewDetails"),
        includedItemsLabel: t("kf.pdp.bundles.includedItems"),
        colorOrFinish: t("kf.pdp.label.colorOrFinish"),
        qty: t("kf.checkout.label.qtyLabel"),
        subTotal: t("kf.pdp.label.subTotal"),
        subTotalItems: (number)=>t("kf.pdp.bundles.subTotalItems", {
                number
            }),
        saveOnBundle: (number)=>t("kf.pdp.bundles.saveOnBundle", {
                number
            }),
        includedItemsQty: (number)=>t("kf.pdp.bundles.includedItemsQty", {
                number
            }),
        includesItemsQty: (number)=>t("kf.pdp.bundles.includesItemsQty", {
                number
            }),
        featuresLabel: t("kf.pdp.label.features"),
        specsInstallationLabel: t("kf.pdp.bundles.specsInstallation"),
        dimensionsLabel: t("kf.pdp.bundles.dimensions"),
        viewMoreLabel: t("kf.pdp.label.viewMore"),
        downloadAllSpecSheetsLabel: t("kf.pdp.bundles.downloadAllSpecSheets"),
        downloadAllInstallGuidesLabel: t("kf.pdp.bundles.downloadAllInstallGuides"),
        cannotShipLabel: t("kf.cart.label.cannotShip"),
        includedPdpItemsLabel: t("kf.pdp.bundles.includedPdpItemsLabel"),
        outOfStockLabel: t("kf.cart.label.outOfStock"),
        outOfStockText: t("kf.pdp.bundles.outOfStock"),
        outOfStockAlert: t("kf.pdp.bundles.alert.outOfStock"),
        quickViewLabel: t("kf.button.quickView"),
        addToCartLabel: t("kf.global.label.addCart"),
        addToCartNote: t("kf.pdp.bundles.addToCartNote"),
        currentPriceAriaLabel: t("kf.pdp.label.currentPrice")
    };
};


/***/ }),

/***/ 6055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ SHIPPED_TAB_VALUE; },
/* harmony export */   "B$": function() { return /* binding */ FULLORDER_TAB_VALUE; },
/* harmony export */   "Fx": function() { return /* binding */ ODP_ANALYTICS_ORDER_SUPPORT; },
/* harmony export */   "HP": function() { return /* binding */ SHIPPED_TAB_ANALYTICS; },
/* harmony export */   "Hl": function() { return /* binding */ ORDER_TYPE_SERVICE; },
/* harmony export */   "K6": function() { return /* binding */ CANCELLED_TAB_ANALYTICS; },
/* harmony export */   "L": function() { return /* binding */ SERVICES_SHIPPING_TYPE; },
/* harmony export */   "Pl": function() { return /* binding */ LINE_ITEM_STATUS_RETURN_REJECTED; },
/* harmony export */   "RS": function() { return /* binding */ ODP_ORDER_SUPPORT_EVENT; },
/* harmony export */   "Rp": function() { return /* binding */ ODP_CUSTOMER_SUPPORT_LINK_TYPE; },
/* harmony export */   "UC": function() { return /* binding */ RETURNED_TAB_ANALYTICS; },
/* harmony export */   "Ur": function() { return /* binding */ LINE_ITEM_STATUS_RETURN_CANCELLED; },
/* harmony export */   "V0": function() { return /* binding */ TAB_ANALYTICS_EVENT; },
/* harmony export */   "Vz": function() { return /* binding */ FULLORDER_TAB_ANALYTICS; },
/* harmony export */   "X6": function() { return /* binding */ CANCELLED_TAB_VALUE; },
/* harmony export */   "YW": function() { return /* binding */ LINE_ITEM_STATUS_SHIPPED; },
/* harmony export */   "aK": function() { return /* binding */ ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME; },
/* harmony export */   "am": function() { return /* binding */ NON_SHIPPED_TABS; },
/* harmony export */   "b8": function() { return /* binding */ ORDER_TYPES_SORT_SEQUENCE; },
/* harmony export */   "cK": function() { return /* binding */ ODP_ANALYTICS_PAGE; },
/* harmony export */   "dm": function() { return /* binding */ LINE_ITEM_STATUS_CANCELLED; },
/* harmony export */   "dt": function() { return /* binding */ ODP_ANALYTICS_NAVIGATION; },
/* harmony export */   "f9": function() { return /* binding */ TABS_TO_SORT; },
/* harmony export */   "hW": function() { return /* binding */ ODP_ANALYTICS_ACCOUNT; },
/* harmony export */   "ik": function() { return /* binding */ INPROGRESS_TAB_ANALYTICS; },
/* harmony export */   "l4": function() { return /* binding */ LINE_ITEM_STATUS_RETURN_ACCEPTED; },
/* harmony export */   "mI": function() { return /* binding */ RETURN_STATUS_SORT_ORDER; },
/* harmony export */   "mJ": function() { return /* binding */ ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME; },
/* harmony export */   "mu": function() { return /* binding */ ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_POSITION; },
/* harmony export */   "rb": function() { return /* binding */ INPROGRESS_TAB_VALUE; },
/* harmony export */   "sN": function() { return /* binding */ LINE_ITEM_STATUS_INPROGRESS; },
/* harmony export */   "uN": function() { return /* binding */ LINE_ITEM_STATUS_RETURN_REQUESTED; },
/* harmony export */   "vy": function() { return /* binding */ RETURNED_TAB_VALUE; }
/* harmony export */ });
/* unused harmony exports LINE_ITEM_STATUS_RETURN_CREATED, ORDER_TYPE_PARCEL, ORDER_TYPE_FREIGHT */
const INPROGRESS_TAB_VALUE = "inprogress";
const FULLORDER_TAB_VALUE = "fullorder";
const SHIPPED_TAB_VALUE = "shipped";
const RETURNED_TAB_VALUE = "returned";
const CANCELLED_TAB_VALUE = "cancelled";
const FULLORDER_TAB_ANALYTICS = "Full Order";
const SHIPPED_TAB_ANALYTICS = "Shipped";
const INPROGRESS_TAB_ANALYTICS = "In Progress";
const RETURNED_TAB_ANALYTICS = "Returned";
const CANCELLED_TAB_ANALYTICS = "Cancelled";
const TAB_ANALYTICS_EVENT = "my account:orders:order details";
const ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME = "my account:orders:order details";
const ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME = "track package";
const ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_POSITION = "my account";
const ODP_ORDER_SUPPORT_EVENT = "my account:orders:order summary";
const ODP_ANALYTICS_PAGE = "orders";
const ODP_ANALYTICS_ACCOUNT = "my account";
const ODP_ANALYTICS_ORDER_SUPPORT = "order details:order support";
const ODP_ANALYTICS_NAVIGATION = "navigation";
const ODP_CUSTOMER_SUPPORT_LINK_TYPE = "order details:customer support";
const LINE_ITEM_STATUS_CANCELLED = "Cancelled";
const LINE_ITEM_STATUS_INPROGRESS = "In Progress";
const LINE_ITEM_STATUS_RETURN_CREATED = "Return Created";
const LINE_ITEM_STATUS_SHIPPED = "Shipped";
const LINE_ITEM_STATUS_RETURN_REQUESTED = "Return Requested";
const LINE_ITEM_STATUS_RETURN_ACCEPTED = "Return Accepted";
const LINE_ITEM_STATUS_RETURN_REJECTED = "Return Rejected";
const LINE_ITEM_STATUS_RETURN_CANCELLED = "Return Cancelled";
const ORDER_TYPE_PARCEL = "Parcel";
const ORDER_TYPE_FREIGHT = "Freight";
const ORDER_TYPE_SERVICE = "Service";
const TABS_TO_SORT = [
    SHIPPED_TAB_VALUE,
    INPROGRESS_TAB_VALUE,
    CANCELLED_TAB_VALUE
];
const NON_SHIPPED_TABS = [
    RETURNED_TAB_VALUE,
    INPROGRESS_TAB_VALUE,
    CANCELLED_TAB_VALUE
];
const RETURN_STATUS_SORT_ORDER = [
    LINE_ITEM_STATUS_RETURN_REQUESTED,
    LINE_ITEM_STATUS_RETURN_ACCEPTED,
    LINE_ITEM_STATUS_RETURN_REJECTED,
    LINE_ITEM_STATUS_RETURN_CANCELLED
];
const ORDER_TYPES_SORT_SEQUENCE = [
    ORDER_TYPE_PARCEL,
    ORDER_TYPE_FREIGHT,
    ORDER_TYPE_SERVICE
];
const SERVICES_SHIPPING_TYPE = [
    "INSTALL SERVICES",
    "DESIGN SERVICES"
];


/***/ }),

/***/ 69162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ cartItemSummaryAnalytics; },
/* harmony export */   "D_": function() { return /* binding */ getTrackingLinkAnalyticsData; },
/* harmony export */   "Xh": function() { return /* binding */ cartBundleFinishAnalytics; }
/* harmony export */ });
/* harmony import */ var _components_cart_CartItemTile_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54114);
/* harmony import */ var _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6055);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55760);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20558);




const getTrackingLinkAnalyticsData = function(link, analyticsData) {
    let isTabsEnabled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, activeTab = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    const tabName = (0,_components_cart_CartItemTile_utils__WEBPACK_IMPORTED_MODULE_0__/* .getFormattedTabNameForAnalytics */ .oH)(activeTab);
    return analyticsData ? JSON.stringify({
        eventAction: "".concat(_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME */ .aK, ":").concat(isTabsEnabled ? _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME */ .mJ : "tracking link"),
        eventName: "".concat(_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME */ .aK, ":").concat(isTabsEnabled ? _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME */ .mJ : "tracking link"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(isTabsEnabled ? _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME */ .mJ : "tracking link"),
        internalLinkPosition: isTabsEnabled ? _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_POSITION */ .mu : "order history",
        internalLinkType: isTabsEnabled ? "".concat(_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME */ .aK, ":").concat(tabName) : "my account:navigation",
        internalLinkZoneName: "".concat(_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_1__/* .ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME */ .aK).concat(isTabsEnabled ? ":".concat(tabName) : ""),
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    }) : null;
};
const cartItemSummaryAnalytics = (analyticTitleData, productInfoData)=>{
    const eventInfo = analyticTitleData ? JSON.parse(analyticTitleData) : {};
    const productInfo = productInfoData ? JSON.parse(productInfoData) : {};
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click", {}, productInfo);
};
const cartBundleFinishAnalytics = function() {
    let bundleLocalStorage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", payloadData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const bundleItems = bundleLocalStorage ? JSON.parse(bundleLocalStorage) : [];
    if (bundleItems.length) {
        const selctedBundle = bundleItems.find((bItem)=>{
            var ref;
            return Array.isArray(bItem === null || bItem === void 0 ? void 0 : bItem.selectedSkus) && (bItem === null || bItem === void 0 ? void 0 : (ref = bItem.selectedSkus) === null || ref === void 0 ? void 0 : ref.includes(payloadData === null || payloadData === void 0 ? void 0 : payloadData.sku));
        });
        if (selctedBundle && !(0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .isObjectEmpty */ .nK)(selctedBundle)) {
            const updatedBundleItems = bundleItems.map((bItem)=>{
                if (bItem.bundleId === selctedBundle.bundleId) {
                    const selectedSkus = bItem === null || bItem === void 0 ? void 0 : bItem.selectedSkus.filter((sku)=>{
                        return sku !== (payloadData === null || payloadData === void 0 ? void 0 : payloadData.sku);
                    });
                    return {
                        ...bItem,
                        selectedSkus
                    };
                }
                return bItem;
            });
            localStorage.setItem("bundleItems", JSON.stringify(updatedBundleItems));
        }
    }
};


/***/ }),

/***/ 54114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hr": function() { return /* binding */ getAllAdditinalInfo; },
/* harmony export */   "PZ": function() { return /* binding */ checkReturnStatus; },
/* harmony export */   "S": function() { return /* binding */ getTmpType; },
/* harmony export */   "WS": function() { return /* binding */ getReturnStatusDescription; },
/* harmony export */   "bO": function() { return /* binding */ servicesItem; },
/* harmony export */   "lk": function() { return /* binding */ getDiscountPrice; },
/* harmony export */   "oH": function() { return /* binding */ getFormattedTabNameForAnalytics; }
/* harmony export */ });
/* harmony import */ var _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6055);

const getTmpType = (param)=>{
    let { category , i18n  } = param;
    var ref;
    const categoryType = (ref = category === null || category === void 0 ? void 0 : category.toLowerCase()) !== null && ref !== void 0 ? ref : "";
    const { perBox ="" , bucket ="" , perEach =""  } = i18n !== null && i18n !== void 0 ? i18n : {};
    if ((categoryType === null || categoryType === void 0 ? void 0 : categoryType.includes("tile")) || (categoryType === null || categoryType === void 0 ? void 0 : categoryType.includes("mosaics"))) {
        return perBox === null || perBox === void 0 ? void 0 : perBox.toLowerCase();
    } else if (categoryType === null || categoryType === void 0 ? void 0 : categoryType.includes("grout")) {
        return "/".concat(bucket === null || bucket === void 0 ? void 0 : bucket.toLowerCase());
    } else if (categoryType === null || categoryType === void 0 ? void 0 : categoryType.includes("trim")) {
        return "".concat(perEach === null || perEach === void 0 ? void 0 : perEach.toLowerCase());
    } else {
        return "";
    }
};
const getAllAdditinalInfo = (e)=>{
    var ref;
    var ref1;
    const { totalarea: totalArea = "" , totaloverageval: overage = "" , soldbyuom: soldByUom = "" , soldbybox: soldByBox = "" , templatetype: templateType = "" , price ="" , name ="" , desc ="" , image ="" , currencysign: currencySign = "" , totalneeded: totalNeeded = "" , discountprice: discountPrice = "" , totalprice: totalPrice = "" , totalSFNeeded ="" , totalUserNeeded ="" , totalSFUserNeeded ="" , totalboxes: totalBoxes = ""  } = (ref1 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.dataset) !== null && ref1 !== void 0 ? ref1 : {};
    return {
        totalArea,
        overage,
        soldByUom,
        soldByBox,
        templateType,
        price,
        name,
        desc,
        image,
        currencySign,
        totalNeeded,
        discountPrice,
        totalPrice,
        totalSFNeeded,
        totalUserNeeded,
        totalSFUserNeeded,
        totalBoxes
    };
};
const getDiscountPrice = (discountPrice, discountUnitPrice, unitPrice)=>{
    if (discountPrice > 0) {
        return discountPrice;
    } else if (discountUnitPrice > 0) {
        return discountUnitPrice;
    } else {
        return unitPrice;
    }
};
const getReturnStatusDescription = function() {
    let status = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", staticText = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { returnRequestedDescription ="" , returnAcceptedDescription ="" , returnRejectedDescription ="" , returnCancelledDescription =""  } = staticText;
    switch(status){
        case _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_REQUESTED */ .uN:
            return returnRequestedDescription;
        case _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_ACCEPTED */ .l4:
            return returnAcceptedDescription;
        case _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_REJECTED */ .Pl:
            return returnRejectedDescription;
        case _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_CANCELLED */ .Ur:
            return returnCancelledDescription;
        default:
            return "";
    }
};
const checkReturnStatus = function() {
    let status = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const returnStatuses = [
        _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_REQUESTED */ .uN,
        _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_ACCEPTED */ .l4,
        _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_REJECTED */ .Pl,
        _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_CANCELLED */ .Ur
    ];
    return returnStatuses.includes(status);
};
const getFormattedTabNameForAnalytics = function() {
    let tabName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    const formattedTabNames = {
        [_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .FULLORDER_TAB_VALUE */ .B$]: _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .FULLORDER_TAB_ANALYTICS */ .Vz,
        [_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .SHIPPED_TAB_VALUE */ .$Q]: _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .SHIPPED_TAB_ANALYTICS */ .HP,
        [_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .INPROGRESS_TAB_VALUE */ .rb]: _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .INPROGRESS_TAB_ANALYTICS */ .ik,
        [_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .RETURNED_TAB_VALUE */ .vy]: _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .RETURNED_TAB_ANALYTICS */ .UC,
        [_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .CANCELLED_TAB_VALUE */ .X6]: _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .CANCELLED_TAB_ANALYTICS */ .K6
    };
    return ((ref = formattedTabNames[tabName]) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "";
};
const servicesItem = (category)=>{
    if (!category) return false;
    var ref;
    const categoryType = (ref = category === null || category === void 0 ? void 0 : category.toUpperCase()) !== null && ref !== void 0 ? ref : "";
    return _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .SERVICES_SHIPPING_TYPE.includes */ .L.includes(categoryType);
};


/***/ }),

/***/ 96514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ addSharedCartItemSummaryAnalytics; },
/* harmony export */   "Jk": function() { return /* binding */ addCartItemSummaryAnalytics; },
/* harmony export */   "UN": function() { return /* binding */ addRemoveProductFromCartAnalytics; },
/* harmony export */   "au": function() { return /* binding */ addDatalayer; },
/* harmony export */   "u$": function() { return /* binding */ analyticsCB; }
/* harmony export */ });
/* unused harmony export calculateCartAnalytics */
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20558);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _components_cart_CartItemTile_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54114);
/* harmony import */ var _store_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88032);





const analyticsCB = function(status) {
    let cartObjData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref;
    const { itemSkus =[] , ...cartObj } = cartObjData;
    const page = window.pageObj || {};
    if (status !== "success" && page.eventInfo) {
        page.eventInfo.eventStatus = "failure";
        page.eventInfo.eventMsg = status || "failed to update item(s) in cart.";
        const otherItems = {};
        if (page.updatedSku) {
            var ref1, ref2;
            // get productInfo and add to event page objet.
            const matchingSku = (ref1 = page.cart) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.item) === null || ref2 === void 0 ? void 0 : ref2.find((prod)=>{
                var ref, ref1;
                return ((ref = prod.productInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.productID) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === page.updatedSku.toLowerCase();
            });
            if (matchingSku) {
                otherItems.productInfo = matchingSku.productInfo;
            }
        }
        otherItems.eventInfo = page.eventInfo;
        delete page.eventInfo;
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            ...otherItems
        });
    } else if (page.eventInfo && cartObj) {
        calculateCartAnalytics({
            itemSkus,
            cart: cartObj,
            eventName: "cmp:click"
        });
    }
    if (window === null || window === void 0 ? void 0 : (ref = window.pageObj) === null || ref === void 0 ? void 0 : ref.updatedSku) {
        delete window.pageObj.updatedSku;
    }
    if (window.pageObj) {
        window.pageObj.cart = cartObj;
    }
    let windowDataLayer = window.adobeDataLayer;
    if (windowDataLayer && windowDataLayer.length > 0 && windowDataLayer[0].page) {
        calculateCartAnalytics({
            itemSkus,
            cart: cartObj
        });
        windowDataLayer = window.adobeDataLayer;
        const winDataLayer = windowDataLayer[windowDataLayer.length];
        if (windowDataLayer.length > 1 && winDataLayer && winDataLayer.event && (winDataLayer.event === "cmp:show" || winDataLayer.event === "cmp:click") && winDataLayer.page && !winDataLayer.page.cart) {
            winDataLayer.page.cart = cartObj;
        }
    }
};
const calculateCartAnalytics = async (data)=>{
    const { itemSkus , cart: cartData , eventName ="cmp:show"  } = data;
    const cart = await (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .mapCollapsedSku */ .eo)({
        itemSkus,
        cart: cartData
    });
    const page = window.pageObj || {};
    page.cartInfo = page.cartInfo || {};
    const finalSkus = itemSkus && itemSkus.length > 0 ? itemSkus.join(",") : (cartData.item || []).map((item)=>{
        var ref;
        return (ref = item.productInfo) === null || ref === void 0 ? void 0 : ref.productID;
    }).filter(Boolean).join(",");
    page.cartInfo.cartItems = finalSkus;
    page.cart = cart;
    page.user = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getUserAnalyticsObject */ .L7i)();
    if (eventName === "cmp:show" && page.user && (!page.user.gId || page.user.gId === "n/a") && (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")) {
        window.pageObj = page;
        window.isShowAnalyticsEvent = true;
    } else if (eventName === "cmp:show" && !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .isShowAnalyticsEventLoaded */ .xJ2)() || eventName !== "cmp:show") {
        let otherItems = {};
        if (eventName !== "cmp:show") {
            var ref;
            if (page.eventInfo) {
                otherItems = {
                    eventInfo: page.eventInfo
                };
                delete page.eventInfo;
            }
            const matchedItem = cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.find((prod)=>{
                var ref;
                return ((ref = prod.productInfo) === null || ref === void 0 ? void 0 : ref.productUpdated) === true;
            });
            if (matchedItem) {
                // here check initialQuantity from oldCart object.
                if (window.oldValue) {
                    matchedItem.productInfo.initialQuantity = window.oldValue;
                    delete window.oldValue;
                }
                otherItems.productInfo = matchedItem.productInfo;
            }
        }
        window.adobeDataLayer.push({
            event: eventName,
            page,
            ...otherItems
        });
    }
};
const addCartItemSummaryAnalytics = function(page, prodDesc, prodName, pdpNavigationURL) {
    let isBundleParent = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", isTabsEnabled = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, activeTab = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "";
    const selectedTab = (0,_components_cart_CartItemTile_utils__WEBPACK_IMPORTED_MODULE_3__/* .getFormattedTabNameForAnalytics */ .oH)(activeTab);
    const isBundleProduct = isBundleParent && page === "cart" || isBundleParent && page === "checkout" || isBundleParent && page === "pdp" ? ":bundle" : "";
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "".concat(page !== "cart" && page !== "checkout" && page !== "pdp" ? "my account:orders:".concat(isTabsEnabled ? "order details" : "order summary") : page === "cart" ? "cart preview" : page, ":product navigation"),
        eventMsg: "n/a",
        eventName: "".concat(page !== "cart" && page !== "checkout" && page !== "pdp" ? "my account:orders:".concat(isTabsEnabled ? "order details" : "order summary") : page === "cart" ? "cart preview" : page, ":product navigation"),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(prodName || prodDesc),
        internalLinkPosition: page !== "cart" && page !== "checkout" && page !== "pdp" ? "my account" : page + isBundleProduct,
        internalLinkType: "".concat(page !== "cart" && page !== "checkout" && page !== "pdp" ? "my account" : page, ":navigation").concat(page !== "cart" && page !== "checkout" && page !== "pdp" && isTabsEnabled ? ":".concat(selectedTab) : ""),
        internalLinkURL: pdpNavigationURL ? ((pdpNavigationURL === null || pdpNavigationURL === void 0 ? void 0 : pdpNavigationURL.indexOf("http")) === -1 ? window.location.origin : "") + pdpNavigationURL : "n/a",
        internalLinkZoneName: page !== "cart" && page !== "checkout" && page !== "pdp" ? "".concat(isTabsEnabled ? "my account:orders:order details:".concat(selectedTab) : "my account:orders:order summary") : page + ":preview"
    });
};
const addRemoveProductFromCartAnalytics = async function(action) {
    let isBundleParent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", cartItemProductInfo = arguments.length > 2 ? arguments[2] : void 0;
    const eventInfo = {
        eventAction: "cart:landing page:remove",
        eventName: "cart:landing page:remove",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "remove",
        internalLinkPosition: "cart".concat(isBundleParent ? ":bundle" : ""),
        internalLinkType: "cart:navigation",
        internalLinkZoneName: "cart:landing page:cart items",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    sessionStorage.setItem("cartLanding", eventInfo.searchCount);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { cart: { cart: cartObj = {}  } = {}  } = (_store_index__WEBPACK_IMPORTED_MODULE_4__/* .store */ .h === null || _store_index__WEBPACK_IMPORTED_MODULE_4__/* .store */ .h === void 0 ? void 0 : _store_index__WEBPACK_IMPORTED_MODULE_4__/* .store.getState */ .h.getState()) || {};
    if (cartObj) {
        const { cart , cartInfo  } = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .calculateCartData */ .DpP)({
            cart: cartObj
        }, true);
        page.cart = cart;
        page.cartInfo = cartInfo;
    }
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: cartItemProductInfo === null || cartItemProductInfo === void 0 ? void 0 : cartItemProductInfo.productInfo
    });
};
const addDatalayer = (params)=>{
    var ref;
    const { section =null , title =null , productInfo =null , calculatedValues =null , sqaureFeetSelection =null , tooltipVal =null  } = params;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const componentName = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.subCategoryID;
    const productInfoJSON = (productInfo === null || productInfo === void 0 ? void 0 : productInfo.length) > 0 ? {
        productInfo: JSON.parse(productInfo)
    } : null;
    const getcalculatedValues = (calculatedValues === null || calculatedValues === void 0 ? void 0 : calculatedValues.length) > 0 ? JSON.parse(calculatedValues) : null;
    let internalLinkName;
    let internalLinkType;
    if (title === "recalculate footage") {
        internalLinkName = "recalculate";
        internalLinkType = "".concat(componentName, ":navigation");
    } else if (title === "calculate footage") {
        internalLinkName = sqaureFeetSelection ? "square feet changed" : "overage selection";
    } else if (title === "info icon mouseover") {
        internalLinkName = tooltipVal;
        internalLinkType = "".concat(componentName, ":mouseover");
    }
    const eventInfo = {
        eventAction: "".concat(componentName, ":landing page:").concat(section, ":").concat(title),
        eventName: "".concat(componentName, ":landing page:").concat(section, ":").concat(title),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkName || "".concat(title),
        internalLinkPosition: "".concat(componentName),
        internalLinkType: internalLinkType || "".concat(componentName, ":").concat(title),
        internalLinkZoneName: "".concat(componentName, ":landing page:").concat(section),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        ...getcalculatedValues
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        ...productInfoJSON
    });
};
const addSharedCartItemSummaryAnalytics = function() {
    let page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", subpage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", prodDesc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", prodName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", pdpNavigationURL = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", isBundleParent = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    const isBundleProduct = isBundleParent ? ":bundle" : "";
    const landingPageInfo = "".concat(page, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.PAGE_TYPES === null || _constants_index__WEBPACK_IMPORTED_MODULE_2__.PAGE_TYPES === void 0 ? void 0 : _constants_index__WEBPACK_IMPORTED_MODULE_2__.PAGE_TYPES.SHARE_CART_LANDING_PAGE);
    const shareCartPage = "".concat(landingPageInfo, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.NAVIGATION_TYPE.PRODUCT);
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: shareCartPage,
        eventMsg: "n/a",
        eventName: shareCartPage,
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(prodName || prodDesc),
        internalLinkPosition: subpage + isBundleProduct,
        internalLinkType: "".concat(subpage, ":navigation"),
        internalLinkURL: pdpNavigationURL ? ((pdpNavigationURL === null || pdpNavigationURL === void 0 ? void 0 : pdpNavigationURL.indexOf("http")) === -1 ? window.location.origin : "") + pdpNavigationURL : "n/a",
        internalLinkZoneName: landingPageInfo
    });
};


/***/ }),

/***/ 5777:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ChildItems":"BundleChildItems_ChildItems__zonWx"};

/***/ }),

/***/ 58177:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BundleSectionWrapper":"StaticBundle_BundleSectionWrapper__yPZzX","fadeInOpacity":"StaticBundle_fadeInOpacity__oONw0"};

/***/ })

}]);